import React, { useContext, useEffect, Fragment } from "react";
import { Button } from "react-admin";
import _ from "lodash";
import { isDisplayable } from "util/misc";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import RootRef from "@material-ui/core/RootRef";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";
import useModal from "games/useModal";
import Play from "./PlayBase";
import { getIsEndOfGame } from "games/utils";

const PlayCreate = () => {
  const {
    usePlayByPlay: [state, dispatch]
  } = useContext(PlayByPlayContext);
  const plays = _.get(state, "plays");
  const theme = useTheme();
  const classes = makeStyles({
    button: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1)
    }
  })();
  const { handleOpenClick, handleCloseClick, showDialog } = useModal();

  const arePlays = isDisplayable(plays);
  let buttonRef = null;
  const setButtonRef = (el) => {
    buttonRef = el;
  };
  const lastPlay = _.get(plays, plays.length - 1, {});
  const lastPlayQuarter = _.get(lastPlay, "quarter");
  const displayQuarter =
    lastPlayQuarter <= 4
      ? `Quarter ${lastPlayQuarter}`
      : `Overtime ${lastPlayQuarter - 4}`;
  const isTie = lastPlay.homeTotalPoints === lastPlay.awayTotalPoints;
  const isEndOfGame = getIsEndOfGame(lastPlay);

  let extraButtonText = "";
  if (isTie && lastPlayQuarter === 4) {
    extraButtonText = " - Go into overtime";
  } else if (isTie && lastPlayQuarter === 5) {
    extraButtonText = " - Go into 2nd overtime";
  } else if (isTie && lastPlayQuarter === 6) {
    extraButtonText = " - Go into 3rd overtime";
  } else if (lastPlayQuarter >= 4 && !isTie) {
    extraButtonText = " - End Game";
  }

  const quarterButtonText = `End ${displayQuarter}${extraButtonText}`;

  useEffect(() => {
    if (!buttonRef) return;
    buttonRef.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleQuarterClick = () => {
    if (
      lastPlayQuarter >= 4 &&
      !isTie &&
      !window.confirm(`Are you sure you want to end the game?`)
    )
      return;
    dispatch({
      type: "endQuarter"
    });
  };

  return (
    <Fragment>
      {!isEndOfGame && (
        <RootRef rootRef={setButtonRef}>
          <Button
            label={arePlays ? "Add New Play" : "Start Game"}
            onClick={handleOpenClick}
            variant="contained"
            color="primary"
            className={classes.button}
          ></Button>
        </RootRef>
      )}
      {!isEndOfGame && arePlays && lastPlay.playType !== "endOfQuarter" && (
        <Button
          label={quarterButtonText}
          color="secondary"
          variant="contained"
          className={classes.button}
          onClick={handleQuarterClick}
        ></Button>
      )}
      <Play
        handleCloseClick={handleCloseClick}
        showDialog={showDialog}
        actionOnSubmit="addNewPlay"
        dialogTitle="Create Play"
      />
    </Fragment>
  );
};

export default PlayCreate;
